// // // // src/components/admin/CategoryCompanyManagement.jsx

// // // import React, { useEffect, useState } from "react";
// // // import { Spinner, Alert, Table, Button, Form, FormControl, Badge, Card } from "react-bootstrap";
// // // import { getCompaniesByCategory, updateCompany } from "../../../services/adminService"; // Adjust path as needed

// // // const CategoryCompanyManagement = ({ categoryId, categoryName, onBack }) => {
// // //   const [companies, setCompanies] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState("");
// // //   const [editingRankId, setEditingRankId] = useState(null); // ID of the company being edited
// // //   const [newRankValue, setNewRankValue] = useState(""); // Value for the input field

// // //   const fetchCompanies = async () => {
// // //     if (!categoryId) {
// // //       setError("No category ID provided.");
// // //       return;
// // //     }
// // //     try {
// // //       setLoading(true);
// // //       setError("");
// // //       const res = await getCompaniesByCategory(categoryId);
// // //       const combinedCompanies = [...res.data.data.top20, ...res.data.data.alphabetical];

// // //       // Sort the combined list for consistent display in the management table
// // //       combinedCompanies.sort((a, b) => {
// // //         // Companies with priorityRank come first, sorted by rank
// // //         if (a.priorityRank && b.priorityRank) return a.priorityRank - b.priorityRank;
// // //         if (a.priorityRank) return -1; // a has rank, b doesn't, a comes first
// // //         if (b.priorityRank) return 1;  // b has rank, a doesn't, b comes first
// // //         return a.name.localeCompare(b.name); // If neither has rank, sort alphabetically
// // //       });

// // //       setCompanies(combinedCompanies);
// // //       setLoading(false);
// // //     } catch (err) {
// // //       console.error("Error fetching companies by category:", err.response?.data || err.message);
// // //       setError(err.response?.data?.message || "Failed to fetch companies for this category.");
// // //       setLoading(false);
// // //       setCompanies([]);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchCompanies();
// // //   }, [categoryId]);

// // //   const handleEditClick = (company) => {
// // //     setEditingRankId(company._id);
// // //     setNewRankValue(company.priorityRank === null ? "" : company.priorityRank.toString());
// // //   };

// // //   const handleCancelEdit = () => {
// // //     setEditingRankId(null);
// // //     setNewRankValue("");
// // //   };

// // //   const handleSaveRank = async (companyId) => {
// // //     try {
// // //       setError("");
// // //       let rankToSave = null;
// // //       if (newRankValue !== "") {
// // //         const parsedRank = parseInt(newRankValue, 10);
// // //         if (isNaN(parsedRank) || parsedRank < 1 || parsedRank > 20) {
// // //           setError("Priority Rank must be a number between 1 and 20, or empty.");
// // //           return;
// // //         }
// // //         rankToSave = parsedRank;
// // //       }

// // //       await updateCompany(companyId, { priorityRank: rankToSave });
// // //       setEditingRankId(null);
// // //       setNewRankValue("");
// // //       fetchCompanies(); // Re-fetch to see the updated rank and sorting
// // //     } catch (err) {
// // //       console.error("Error updating priority rank:", err.response?.data || err.message);
// // //       setError(err.response?.data?.message || "Failed to update priority rank.");
// // //     }
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <div className="text-center mt-5">
// // //         <Spinner animation="border" />
// // //         <p>Loading companies for management...</p>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <div className="container mt-4">
// // //       <div className="d-flex justify-content-between align-items-center mb-4">
// // //         <h2>Manage Companies in <Badge bg="primary">{categoryName || "Category"}</Badge></h2>
// // //         <Button variant="secondary" onClick={onBack}>Back to Categories</Button>
// // //       </div>

// // //       {error && <Alert variant="danger" className="mt-4">{error}</Alert>}

// // //       {companies.length === 0 && !loading && !error ? (
// // //         <Alert variant="info" className="text-center">
// // //           No approved companies found for {categoryName || "this category"} to manage.
// // //         </Alert>
// // //       ) : (
// // //         <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
// // //           <thead className="table-dark">
// // //             <tr>
// // //               <th>#</th>
// // //               <th>Logo</th>
// // //               <th>Company Name</th>
// // //               <th>Type</th>
// // //               <th>Current Rank</th>
// // //               <th>Set New Rank (1-20 or empty)</th>
// // //               <th>Actions</th>
// // //             </tr>
// // //           </thead>
// // //           <tbody>
// // //             {companies.map((company, index) => (
// // //               <tr key={company._id}>
// // //                 <td>{index + 1}</td>
// // //                 <td>
// // //                   {company.logo ? (
// // //                     <img
// // //                       src={company.logo}
// // //                       alt={company.name}
// // //                       style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
// // //                     />
// // //                   ) : (
// // //                     "—"
// // //                   )}
// // //                 </td>
// // //                 <td className="fw-semibold">{company.name}</td>
// // //                 <td>
// // //                   <Badge bg={company.companyType === "service" ? "info" : "success"}>{company.companyType}</Badge>
// // //                 </td>
// // //                 <td>
// // //                   {company.priorityRank ? <Badge bg="warning">#{company.priorityRank}</Badge> : "None"}
// // //                 </td>
// // //                 <td>
// // //                   {editingRankId === company._id ? (
// // //                     <div className="d-flex justify-content-center align-items-center">
// // //                       <FormControl
// // //                         type="number"
// // //                         min="1"
// // //                         max="20"
// // //                         placeholder="1-20 or empty"
// // //                         value={newRankValue}
// // //                         onChange={(e) => setNewRankValue(e.target.value)}
// // //                         style={{ width: '120px' }}
// // //                         className="me-2"
// // //                       />
// // //                       <Button variant="success" size="sm" onClick={() => handleSaveRank(company._id)}>
// // //                         Save
// // //                       </Button>
// // //                       <Button variant="secondary" size="sm" className="ms-2" onClick={handleCancelEdit}>
// // //                         Cancel
// // //                       </Button>
// // //                     </div>
// // //                   ) : (
// // //                     <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(company)}>
// // //                       {company.priorityRank ? "Change Rank" : "Set Rank"}
// // //                     </Button>
// // //                   )}
// // //                 </td>
// // //                 <td>
// // //                   {/* You can add more actions here like 'Edit Company Details', 'Delete Company' */}
// // //                   <Button variant="secondary" size="sm" className="me-2">View Details</Button>
// // //                   {/* Example: <Button variant="danger" size="sm">Delete</Button> */}
// // //                 </td>
// // //               </tr>
// // //             ))}
// // //           </tbody>
// // //         </Table>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default CategoryCompanyManagement;

// // // src/components/admin/CategoryCompanyManagement.jsx (Final Corrected Code)


// // import React, { useEffect, useState } from "react";
// // import { Spinner, Alert, Table, Button, Form, FormControl, Badge, Card } from "react-bootstrap";
// // import { getCompaniesByCategory, updateCompany } from "../../../services/adminService"; // Adjust path as needed

// // const CategoryCompanyManagement = ({ categoryId, categoryName, onBack }) => {
// //   const [companies, setCompanies] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState("");
// //   const [editingRankId, setEditingRankId] = useState(null);
// //   const [newRankValue, setNewRankValue] = useState("");

// //   useEffect(() => {
// //     console.log("CategoryCompanyManagement mounted/categoryId changed. categoryId:", categoryId, "categoryName:", categoryName);
// //     if (!categoryId) {
// //       setError("Category ID is missing. Cannot fetch companies for management.");
// //     }
// //   }, [categoryId, categoryName]);

// //   const fetchCompanies = async () => {
// //     if (!categoryId) {
// //       console.error("fetchCompanies aborted: categoryId is missing.");
// //       setError("Cannot fetch companies: Category ID is not available.");
// //       setLoading(false);
// //       return;
// //     }

// //     try {
// //       setLoading(true);
// //       setError("");
// //       console.log(`Attempting to fetch companies for category ID: ${categoryId}`);

// //       const res = await getCompaniesByCategory(categoryId);
// //       console.log("Step 1: Raw 'res' from getCompaniesByCategory (service function):", res); // Log 1

// //       // --- IMPORTANT DEBUGGING LOGS HERE ---
// //       console.log("Step 2: Checking res.success:", res?.success);
// //       console.log("Step 3: Checking res.data:", res?.data);
// //       console.log("Step 4: Checking res.data.top20:", res?.data?.top20);
// //       console.log("Step 5: Checking res.data.alphabetical:", res?.data?.alphabetical);
// //       // --- END IMPORTANT DEBUGGING LOGS ---


// //       // Validate the response structure (This is the line causing your error if old code is running)
// //       // The 'res' here is ALREADY res.data from the service call.
// //       // So it should be `if (!res || !res.data || !res.data.top20 || !res.data.alphabetical)`
// //       // But since your backend consistently wraps in `data: {top20, alphabetical}`,
// //       // and adminService returns `res.data`, the `res` object in this controller
// //       // should directly have `top20` and `alphabetical` properties inside its `data` property.
// //       // Let's adjust the validation slightly to be more robust for the incoming `res` structure from `adminService`
// //       if (!res || !res.data || !Array.isArray(res.data.top20) || !Array.isArray(res.data.alphabetical)) {
// //           console.error("Validation failed: Incoming 'res' object structure is incorrect.", { res }); // Log the problematic res object
// //           throw new Error("Invalid response structure received from the server. Expected { data: { top20: [], alphabetical: [] } }");
// //       }


// //       const { top20, alphabetical } = res.data; // Now accessing directly from res.data as adminService returns res.data
// //       const combinedCompanies = [...top20, ...alphabetical];
// //       console.log("Fetched top20 companies:", top20);
// //       console.log("Fetched alphabetical companies:", alphabetical);
// //       console.log("Combined companies before sorting for display:", combinedCompanies);

// //       combinedCompanies.sort((a, b) => {
// //         const rankA = a.priorityRank === null || a.priorityRank === undefined ? Infinity : a.priorityRank;
// //         const rankB = b.priorityRank === null || b.priorityRank === undefined ? Infinity : b.priorityRank;

// //         if (rankA !== Infinity && rankB !== Infinity) return rankA - rankB;
// //         if (rankA !== Infinity) return -1;
// //         if (rankB !== Infinity) return 1;
// //         return a.name.localeCompare(b.name);
// //       });
// //       console.log("Companies after sorting for display:", combinedCompanies);

// //       setCompanies(combinedCompanies);
// //       setLoading(false);

// //     } catch (err) {
// //       console.error("Caught error during fetchCompanies in CategoryCompanyManagement:", err);
// //       const errorMessage = err.response?.data?.message || err.message || "An unknown error occurred.";
// //       setError(` ${errorMessage}`);
// //       setLoading(false);
// //       setCompanies([]);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchCompanies();
// //   }, [categoryId]);

// //   const handleEditClick = (company) => {
// //     console.log("Editing company:", company.name, "Current Rank:", company.priorityRank);
// //     setEditingRankId(company._id);
// //     setNewRankValue(company.priorityRank?.toString() || "");
// //   };

// //   const handleCancelEdit = () => {
// //     console.log("Cancelling edit for:", editingRankId);
// //     setEditingRankId(null);
// //     setNewRankValue("");
// //   };

// //   const handleSaveRank = async (companyId) => {
// //     try {
// //       setError("");
// //       let rankToSave = null;
// //       if (newRankValue !== "") {
// //         const parsedRank = parseInt(newRankValue, 10);
// //         if (isNaN(parsedRank) || parsedRank < 1 || parsedRank > 20) {
// //           setError("Priority Rank must be a number between 1 and 20, or empty to remove.");
// //           return;
// //         }
// //         rankToSave = parsedRank;
// //       }
// //       console.log(`Attempting to save rank ${rankToSave} for company ID: ${companyId}`);
// //       await updateCompany(companyId, { priorityRank: rankToSave });
// //       console.log("Rank updated successfully for company ID:", companyId);
// //       setEditingRankId(null);
// //       setNewRankValue("");
// //       fetchCompanies();
// //     } catch (err) {
// //       console.error("Error updating priority rank:", err.response?.data || err.message, err);
// //       setError(err.response?.data?.message || `Failed to update priority rank: ${err.message}`);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <div className="text-center mt-5">
// //         <Spinner animation="border" />
// //         <p>Loading companies for management...</p>
// //       </div>
// //     );
// //   }

// //   console.log("--- CategoryCompanyManagement Render Cycle ---");
// //   console.log("Current 'companies' state (before JSX):", companies);
// //   console.log("Is 'companies' array empty?", companies.length === 0);
// //   console.log("Is 'error' present?", !!error);
// //   console.log("--- End Render Cycle Logs ---");

// //   return (
// //     <div className="container mt-4">
// //       <div className="d-flex justify-content-between align-items-center mb-4">
// //         <h2>Manage Companies in <Badge bg="primary">{categoryName || "Category"}</Badge></h2>
// //         <Button variant="secondary" onClick={onBack}>Back to Categories</Button>
// //       </div>

// //       {error && <Alert variant="danger" className="mt-4">{error}</Alert>}

// //       {companies.length === 0 && !loading && !error && (
// //         <Alert variant="info" className="text-center">
// //           No approved companies found for {categoryName || "this category"} to manage.
// //         </Alert>
// //       )}

// //       {companies.length > 0 && (
// //         <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
// //           <thead className="table-dark">
// //             <tr>
// //               <th>#</th>
// //               <th>Logo</th>
// //               <th>Company Name</th>
// //               <th>Type</th>
// //               <th>Current Rank</th>
// //               <th>Set New Rank (1-20 or empty)</th>
// //               <th>Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {companies.map((company, index) => (
// //               <tr key={company._id}>
// //                 <td>{index + 1}</td>
// //                 <td>
// //                   {company.logo ? (
// //                     <img
// //                       src={company.logo}
// //                       alt={company.name}
// //                       style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
// //                     />
// //                   ) : (
// //                     "—"
// //                   )}
// //                 </td>
// //                 <td className="fw-semibold">{company.name}</td>
// //                 <td>
// //                   <Badge bg={company.companyType === "service" ? "info" : "success"}>{company.companyType}</Badge>
// //                 </td>
// //                 <td>
// //                   {company.priorityRank ? <Badge bg="warning">#{company.priorityRank}</Badge> : "None"}
// //                 </td>
// //                 <td>
// //                   {editingRankId === company._id ? (
// //                     <div className="d-flex justify-content-center align-items-center">
// //                       <FormControl
// //                         type="number"
// //                         min="1"
// //                         max="20"
// //                         placeholder="1-20 or empty"
// //                         value={newRankValue}
// //                         onChange={(e) => setNewRankValue(e.target.value)}
// //                         style={{ width: '120px' }}
// //                         className="me-2"
// //                       />
// //                       <Button variant="success" size="sm" onClick={() => handleSaveRank(company._id)}>
// //                         Save
// //                       </Button>
// //                       <Button variant="secondary" size="sm" className="ms-2" onClick={handleCancelEdit}>
// //                         Cancel
// //                       </Button>
// //                     </div>
// //                   ) : (
// //                     <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(company)}>
// //                       {company.priorityRank ? "Change Rank" : "Set Rank"}
// //                     </Button>
// //                   )}
// //                 </td>
// //                 <td>
// //                   {/* You can add more actions here like 'Edit Company Details', 'Delete Company' */}
// //                   <Button variant="secondary" size="sm" className="me-2">View Details</Button>
// //                 </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </Table>
// //       )}
// //     </div>
// //   );
// // };

// // export default CategoryCompanyManagement;


// import React, { useEffect, useState } from "react";
// import { Spinner, Alert, Table, Button, FormControl, Badge } from "react-bootstrap";
// import { getCompaniesByCategory, updateCompany } from "../../../services/adminService"; // Adjust path if needed

// const CategoryCompanyManagement = ({ categoryId, categoryName, onBack }) => {
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [editingRankId, setEditingRankId] = useState(null);
//   const [newRankValue, setNewRankValue] = useState("");

//   // Fetch companies by category
//   const fetchCompanies = async () => {
//     if (!categoryId) {
//       setError("Cannot fetch companies: Category ID missing.");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       const res = await getCompaniesByCategory(categoryId);

//       if (!res || !res.data || !Array.isArray(res.data.top20) || !Array.isArray(res.data.alphabetical)) {
//         throw new Error("Invalid response structure received from the server.");
//       }

//       const { top20, alphabetical } = res.data;
//       const combinedCompanies = [...top20, ...alphabetical];

//       combinedCompanies.sort((a, b) => {
//         const rankA = a.priorityRank === null || a.priorityRank === undefined ? Infinity : a.priorityRank;
//         const rankB = b.priorityRank === null || b.priorityRank === undefined ? Infinity : b.priorityRank;
//         if (rankA !== Infinity && rankB !== Infinity) return rankA - rankB;
//         if (rankA !== Infinity) return -1;
//         if (rankB !== Infinity) return 1;
//         return a.name.localeCompare(b.name);
//       });

//       setCompanies(combinedCompanies);
//     } catch (err) {
//       console.error("Error fetching companies:", err);
//       setError(err.response?.data?.message || err.message || "Failed to load companies.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, [categoryId]);

//   // Handle Edit Rank
//   const handleEditClick = (company) => {
//     setEditingRankId(company._id);
//     setNewRankValue(company.priorityRank?.toString() || "");
//   };

//   const handleCancelEdit = () => {
//     setEditingRankId(null);
//     setNewRankValue("");
//   };

//   // Save Rank (Add/Change)
//   const handleSaveRank = async (companyId) => {
//     try {
//       setError("");
//       let rankToSave = null;

//       if (newRankValue !== "") {
//         const parsedRank = parseInt(newRankValue, 10);
//         if (isNaN(parsedRank) || parsedRank < 1 || parsedRank > 20) {
//           setError("Priority Rank must be a number between 1 and 20, or empty to remove.");
//           return;
//         }
//         rankToSave = parsedRank;
//       }

//       await updateCompany(companyId, { priorityRank: rankToSave });
//       setEditingRankId(null);
//       setNewRankValue("");
//       fetchCompanies();
//     } catch (err) {
//       console.error("Error updating rank:", err);
//       setError(err.response?.data?.message || "Failed to update rank.");
//     }
//   };

//   // Remove from Top 20
//   const handleSaveRankRemove = async (companyId) => {
//     try {
//       setError("");
//       await updateCompany(companyId, { priorityRank: "" }); // Empty -> remove from Top 20
//       fetchCompanies();
//     } catch (err) {
//       console.error("Error removing from Top 20:", err);
//       setError(err.response?.data?.message || "Failed to remove from Top 20.");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center mt-5">
//         <Spinner animation="border" />
//         <p>Loading companies for management...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>
//           Manage Companies in <Badge bg="primary">{categoryName || "Category"}</Badge>
//         </h2>
//         <Button variant="secondary" onClick={onBack}>
//           Back to Categories
//         </Button>
//       </div>

//       {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

//       {companies.length === 0 && !loading && !error && (
//         <Alert variant="info" className="text-center">
//           No approved companies found for {categoryName || "this category"} to manage.
//         </Alert>
//       )}

//       {companies.length > 0 && (
//         <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Logo</th>
//               <th>Company Name</th>
//               <th>Type</th>
//               <th>Current Rank</th>
//               <th>Set / Change Rank</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {companies.map((company, index) => (
//               <tr key={company._id}>
//                 <td>{index + 1}</td>
//                 <td>
//                   {company.logo ? (
//                     <img
//                       src={company.logo}
//                       alt={company.name}
//                       style={{
//                         width: "50px",
//                         height: "50px",
//                         objectFit: "cover",
//                         borderRadius: "6px",
//                       }}
//                     />
//                   ) : (
//                     "—"
//                   )}
//                 </td>
//                 <td className="fw-semibold">{company.name}</td>
//                 <td>
//                   <Badge bg={company.companyType === "service" ? "info" : "success"}>
//                     {company.companyType}
//                   </Badge>
//                 </td>
//                 <td>
//                   {company.priorityRank ? (
//                     <Badge bg="warning">#{company.priorityRank}</Badge>
//                   ) : (
//                     <span className="text-muted">None</span>
//                   )}
//                 </td>
//                 <td>
//                   {editingRankId === company._id ? (
//                     <div className="d-flex justify-content-center align-items-center">
//                       <FormControl
//                         type="number"
//                         min="1"
//                         max="20"
//                         placeholder="1-20 or empty"
//                         value={newRankValue}
//                         onChange={(e) => setNewRankValue(e.target.value)}
//                         style={{ width: "120px" }}
//                         className="me-2"
//                       />
//                       <Button
//                         variant="success"
//                         size="sm"
//                         onClick={() => handleSaveRank(company._id)}
//                       >
//                         Save
//                       </Button>
//                       <Button
//                         variant="secondary"
//                         size="sm"
//                         className="ms-2"
//                         onClick={handleCancelEdit}
//                       >
//                         Cancel
//                       </Button>
//                     </div>
//                   ) : (
//                     <div className="d-flex justify-content-center align-items-center">
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         onClick={() => handleEditClick(company)}
//                       >
//                         {company.priorityRank ? "Change Rank" : "Set Rank"}
//                       </Button>

//                       {company.priorityRank && (
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           className="ms-2"
//                           onClick={() => handleSaveRankRemove(company._id)}
//                         >
//                           Remove from Top 20
//                         </Button>
//                       )}
//                     </div>
//                   )}
//                 </td>
//                 <td>
//                   <Button variant="secondary" size="sm">
//                     View Details
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//     </div>
//   );
// };

// export default CategoryCompanyManagement;


import React, { useEffect, useState } from "react";
import { Spinner, Alert, Table, Button, FormControl, Badge, Form } from "react-bootstrap";
import { getCompaniesByCategory, updateCompany } from "../../../services/adminService";

const CategoryCompanyManagement = ({ categoryId, categoryName, onBack }) => {
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editingRankId, setEditingRankId] = useState(null);
  const [newRankValue, setNewRankValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch companies by category
  const fetchCompanies = async () => {
    if (!categoryId) {
      setError("Cannot fetch companies: Category ID missing.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const res = await getCompaniesByCategory(categoryId);

      if (!res || !res.data || !Array.isArray(res.data.top20) || !Array.isArray(res.data.alphabetical)) {
        throw new Error("Invalid response structure received from the server.");
      }

      const { top20, alphabetical } = res.data;
      let combinedCompanies = [...top20, ...alphabetical];

      combinedCompanies.sort((a, b) => {
        const rankA = a.priorityRank === null || a.priorityRank === undefined ? Infinity : a.priorityRank;
        const rankB = b.priorityRank === null || b.priorityRank === undefined ? Infinity : b.priorityRank;
        if (rankA !== Infinity && rankB !== Infinity) return rankA - rankB;
        if (rankA !== Infinity) return -1;
        if (rankB !== Infinity) return 1;
        return a.name.localeCompare(b.name);
      });

      setCompanies(combinedCompanies);
      setFilteredCompanies(combinedCompanies);
    } catch (err) {
      console.error("Error fetching companies:", err);
      setError(err.response?.data?.message || err.message || "Failed to load companies.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, [categoryId]);

  // SEARCH FILTER FUNCTION
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCompanies(companies);
    } else {
      const filtered = companies.filter((c) =>
        c.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCompanies(filtered);
    }
  }, [searchTerm, companies]);

  // Handle Edit Rank
  const handleEditClick = (company) => {
    setEditingRankId(company._id);
    setNewRankValue(company.priorityRank?.toString() || "");
  };

  const handleCancelEdit = () => {
    setEditingRankId(null);
    setNewRankValue("");
  };

  // Save Rank (Add/Change)
  const handleSaveRank = async (companyId) => {
    try {
      setError("");
      let rankToSave = null;

      if (newRankValue !== "") {
        const parsedRank = parseInt(newRankValue, 10);
        if (isNaN(parsedRank) || parsedRank < 1 || parsedRank > 20) {
          setError("Priority Rank must be a number between 1 and 20, or empty to remove.");
          return;
        }
        rankToSave = parsedRank;
      }

      await updateCompany(companyId, { priorityRank: rankToSave });
      setEditingRankId(null);
      setNewRankValue("");
      fetchCompanies();
    } catch (err) {
      console.error("Error updating rank:", err);
      setError(err.response?.data?.message || "Failed to update rank.");
    }
  };

  // Remove from Top 20
  const handleSaveRankRemove = async (companyId) => {
    try {
      setError("");
      await updateCompany(companyId, { priorityRank: "" });
      fetchCompanies();
    } catch (err) {
      console.error("Error removing from Top 20:", err);
      setError(err.response?.data?.message || "Failed to remove from Top 20.");
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
        <p>Loading companies for management...</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>
          Manage Companies in <Badge bg="primary">{categoryName || "Category"}</Badge>
        </h2>
        <Button variant="secondary" onClick={onBack}>
          Back to Categories
        </Button>
      </div>

      {/* SEARCH BAR */}
      <Form className="mb-3">
        <FormControl
          type="text"
          placeholder="Search company..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form>

      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

      {filteredCompanies.length === 0 && !loading && !error && (
        <Alert variant="info" className="text-center">
          No companies match your search.
        </Alert>
      )}

      {filteredCompanies.length > 0 && (
        <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Type</th>
              <th>Current Rank</th>
              <th>Set / Change Rank</th>
          
            </tr>
          </thead>

          <tbody>
            {filteredCompanies.map((company, index) => (
              <tr key={company._id}>
                <td>{index + 1}</td>

                <td>
                  {company.logo ? (
                    <img
                      src={company.logo}
                      alt={company.name}
                      style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "6px" }}
                    />
                  ) : (
                    "—"
                  )}
                </td>

                <td className="fw-semibold">{company.name}</td>

                <td>
                  <Badge bg={company.companyType === "service" ? "info" : "success"}>
                    {company.companyType}
                  </Badge>
                </td>

                <td>
                  {company.priorityRank ? (
                    <Badge bg="warning">#{company.priorityRank}</Badge>
                  ) : (
                    <span className="text-muted">None</span>
                  )}
                </td>

                {/* Set Rank */}
                <td>
                  {editingRankId === company._id ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <FormControl
                        type="number"
                        min="1"
                        max="20"
                        placeholder="1-20 or empty"
                        value={newRankValue}
                        onChange={(e) => setNewRankValue(e.target.value)}
                        style={{ width: "120px" }}
                        className="me-2"
                      />

                      <Button variant="success" size="sm" onClick={() => handleSaveRank(company._id)}>
                        Save
                      </Button>

                      <Button variant="secondary" size="sm" className="ms-2" onClick={handleCancelEdit}>
                        Cancel
                      </Button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">

                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleEditClick(company)}
                      >
                        {company.priorityRank ? "Change Rank" : "Set Rank"}
                      </Button>

                      {company.priorityRank && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="ms-2"
                          onClick={() => handleSaveRankRemove(company._id)}
                        >
                          Remove from Top 20
                        </Button>
                      )}
                    </div>
                  )}
                </td>


              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default CategoryCompanyManagement;
